require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-5-mistakes-brands-make-when-going-direct-to-consumer-dtc.json") })
        }
      }, "path---blog-5-mistakes-brands-make-when-going-direct-to-consumer-dtc");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-5-mistakes-brands-make-when-going-direct-to-consumer-dtc!./.cache/json/blog-5-mistakes-brands-make-when-going-direct-to-consumer-dtc.json
// module id = 403
// module chunks = 231608221292675